import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router'

import { EditContainer } from './Edit'
import { usersEdit, USERS_URL, USERS_CREATE_URL } from '../../../constants/urls/frontend'
import { CreateContainer } from './Create'
import { DisplayContainer } from './Display'

const UsersPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <Switch>
      <Route path={usersEdit()} component={EditContainer} />
      <Route path={USERS_CREATE_URL} component={CreateContainer} />
      <Route path={USERS_URL} component={DisplayContainer} />
    </Switch>
  )
}

export {
  UsersPage
}
